import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("h1", { class: "title" }, "Distributor Settings"),
  /*#__PURE__*/_createVNode("p", { class: "subtitle" }, "Modify Distributor Settings")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "buttons is-right mb-2"
}
const _hoisted_5 = { class: "container" }
const _hoisted_6 = {
  key: 0,
  class: "grid-loading-spinner"
}
const _hoisted_7 = { class: "spinner-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editable_grid = _resolveComponent("editable-grid")
  const _component_loadingSpinner = _resolveComponent("loadingSpinner")
  const _component_add_distributor_setting_dialog = _resolveComponent("add-distributor-setting-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("main", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      (_ctx.userAuth.canManageDistributorSettings)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("button", {
              title: "Add new",
              type: "button",
              class: "button is-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAddNew && _ctx.onAddNew(...args)))
            }, " Add new ")
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_5, [
        _createVNode("form", null, [
          _createVNode(_component_editable_grid, {
            isReadOnly: _ctx.userAuth.canManageDistributorSettings,
            items: _ctx.settings,
            columns: _ctx.columns,
            validator: _ctx.validator,
            isToolBarRequired: false,
            onSave: _cache[2] || (_cache[2] = $event => _ctx.updateSetting($event)),
            onItemsUpdated: _cache[3] || (_cache[3] = $event => (_ctx.settings = $event)),
            pageItemsOptions: [10, 20, 50]
          }, null, 8, ["isReadOnly", "items", "columns", "validator"])
        ]),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_loadingSpinner)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_add_distributor_setting_dialog, {
      isVisible: _ctx.isAddDialogVisible,
      onNewDistributorAdded: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onNewDistributorAdded($event))),
      onModalClosed: _ctx.onAddDistributorModalClose
    }, null, 8, ["isVisible", "onModalClosed"])
  ], 64))
}